// Adapts the unified Shiprocket-style catalog payload (bathlane-api) to the
// storefront card/detail shapes the UI components already read. The API
// remains the single source of truth; this module only renames/derives.

const BUCKETS = [
  { max: 18, label: 'Under 18"' },
  { max: 24, label: '18\u201324"' },
  { max: 30, label: '24\u201330"' },
  { max: 36, label: '30\u201336"' },
];

export const bucketOf = (width) => {
  if (width == null) return null;
  for (const b of BUCKETS) if (width < b.max) return b.label;
  return '36"+';
};

export const badgesOf = (tags) =>
  (tags ?? "").split(",").map((t) => t.trim()).filter(Boolean);

const optionValues = (p, name) =>
  (p.options ?? []).find((o) => o.name === name)?.values ?? [];

const blank = (v) => (v === '' || v == null ? null : v);

export const mapCard = (p) => ({
  id: p.id,
  name: p.title,
  price: Number(p.price),
  image: p.image?.src ?? null,
  images: Array.isArray(p.images) && p.images.length ? p.images : p.image?.src ? [p.image.src] : [],
  badges: badgesOf(p.tags),
  widthBucket: bucketOf(blank(p.width)),
  mounting: blank(p.mounting),
  width: blank(p.width),
  finish: blank(p.finish),
  sink: blank(p.sink),
  style: blank(p.style),
  finishFamily: blank(p.finishFamily),
  handle: p.handle,
});

export const mapDetail = (d) => ({
  ...mapCard(d),
  gallery: Array.isArray(d.gallery) ? d.gallery : [],
  story: Array.isArray(d.story) ? d.story : [],
  depth: d.depth ?? null,
  height: d.height ?? null,
  shortDesc: d.shortDesc ?? null,
  basin: d.basin ?? null,
  storage: d.storage ?? null,
  idealSize: d.idealSize ?? null,
  category: d.category ?? null,
  kind: d.kind ?? null,
  variants: {
    finishes: optionValues(d, "Finish"),
    widths: optionValues(d, "Width"),
    sinks: optionValues(d, "Sink"),
  },
  variantList: (d.variants ?? []).map((v) => {
    const ov = v.option_values ?? {};
    return {
      width: blank(ov.Width),
      finish: blank(ov.Finish),
      sink: blank(ov.Sink),
      price: Number(v.price),
    };
  }),
});

export const mapList = ({ data } = {}) => ({
  items: (data?.products ?? []).map(mapCard),
  facets: data?.facets ?? {},
  total: data?.total ?? 0,
  page: data?.page ?? 1,
  limit: data?.limit ?? 100,
});

export const mapRelated = ({ data } = {}) => ({
  items: (data?.products ?? []).map(mapCard),
});